import { render, staticRenderFns } from "./law_info.vue?vue&type=template&id=89aa2a90&scoped=true"
import script from "./law_info.vue?vue&type=script&lang=js"
export * from "./law_info.vue?vue&type=script&lang=js"
import style0 from "./law_info.vue?vue&type=style&index=0&id=89aa2a90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89aa2a90",
  null
  
)

export default component.exports